import React from 'react';
import Head from 'next/head';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WorkType from '@/components/CustomFlow/Roofers/WorkType';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

export async function getStaticProps() {
  return {
    props: {
      category: CATEGORY_SUBSETS.filter((category) => category.url_slug === 'roofers')[0]
    }
  };
}

const Category = ({ category = {} }) => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>
    </Head>
    <Header />
    <WorkType category={category} />
    <Footer />
  </div>
);

export default Category;
